import { type ColDef } from '@ag-grid-community/core';
import { StatusCell } from '@pages/notification-components/components/RequestsCard/RequestsTable/components/StatusCell';
import { UserCell } from '@pages/notification-components/components/RequestsCard/RequestsTable/components/UserCell';
import { type ComponentCreateRequestMapped } from '@pages/notification-components/models/ComponentCreateRequestMapped';

export const RequestTableColumns: ColDef<ComponentCreateRequestMapped>[] = [
    {
        field: 'componentName',
        headerName: 'Name',
    },
    {
        field: 'statusID',
        headerName: 'Status',
        cellRenderer: StatusCell,
    },
    {
        field: 'componentVersion',
        headerName: 'Version',
    },
    {
        colId: 'componentVendorName',
        headerName: 'Vendor',
        valueGetter: ({ data }) =>
            data?.componentVendor?.name ??
            data?.componentVendorName ??
            data?.componentVendorID ??
            '',
        initialHide: true,
    },
    {
        field: 'requestPriority',
        headerName: 'Priority',
        initialHide: true,
    },
    {
        field: 'externalRequestStatus',
        headerName: 'Ext. request status',
        cellRenderer: StatusCell,
        initialHide: true,
    },
    {
        field: 'externalComponentID',
        headerName: 'Ext. component ID',
        initialHide: true,
    },
    {
        field: 'id',
        headerName: 'Request ID',
        initialHide: true,
    },
    {
        field: 'userID',
        headerName: 'Requester',
        cellRenderer: UserCell,
        initialHide: true,
    },
    {
        field: 'referenceWeb',
        headerName: 'Website URL',
        initialHide: true,
    },
    {
        field: 'referenceSecurity',
        headerName: 'Security URL',
        initialHide: true,
    },
];
